import getStore from '../data/store/store';
import getCalendarProcessingOptions from '../services/getCalendarProcessingOptions';
import initializeCalendarProcessingOptions from '../actions/initializeCalendarProcessingOptions';

/**
 * Util to get calendar processing options and initialize store if not present
 */

export default async function initCalendarProcessingOptions() {
    let { calendarProcessingOptions } = getStore();
    if (!calendarProcessingOptions) {
        let calendarOptions = await getCalendarProcessingOptions();
        initializeCalendarProcessingOptions(calendarOptions);
    }
}
